import { DocumentInterface, ItemInterface } from "../interfaces";

/**
 * The VAT the payment screen charges and, through it, the VAT that decides
 * whether "Retención de IVA" is offered at all.
 *
 * The invoice's own tax line wins over the sum of the items. A document read
 * back from the server carries its VAT in `taxes`, straight from
 * `taxAmountBaseCurr`, while the items are hydrated by a batched read that
 * reconciles on the subtotal alone: a response whose tax column came back null
 * still passes that check and leaves `rate.iva` 0 on every item. Summing the
 * items first therefore reported 0 VAT for an invoice that had VAT, and the
 * retention dropdown silently lost its IVA option while the documents modal,
 * which holds no items, kept offering it for the same document.
 *
 * The items remain the fallback for the one case with no document yet: a
 * shipment still being priced.
 */
export const resolveDocumentIva = (
  items: Pick<ItemInterface, "rate">[] | undefined,
  document: Pick<DocumentInterface, "taxes"> | undefined
): number => {
  const documentIva = document?.taxes?.find((tax) => tax.name === "IVA")?.value;

  if (documentIva !== undefined) return documentIva;
  if (!items) return 0;

  return +items.reduce((acc, item) => acc + item.rate.iva, 0).toFixed(2);
};
